// ページ遷移先を判断するためのクラス
export class PageTransition{
    private _page : string = "";

    public set page(page: string){
        this._page = page;
    }

    public get page(): string{
        return this._page;
    }
}